<template>
  <SetRefferer v-if="authStore.profile === null" />
  <CrispChat v-if="authStore.profile === null" />
</template>

<script lang="ts" setup>
import { useAuthStore } from '/@/stores'

import { CrispChat, SetRefferer } from '/@app'

const authStore = useAuthStore()
</script>
